import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt, FaVuejs, FaNodeJs, FaDatabase, FaDocker, FaCalendarCheck, FaStore } from 'react-icons/fa';

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

const features = [
  '多店家美業預約系統，支援美髮、美甲等服務',
  '顧客端四步驟預約流程：選服務 → 選人員 → 選時間 → 填資料',
  '店家後台管理服務項目、設計師與營業時間，可確認/取消預約',
  '總管理端管理店家帳號、綜覽全站預約與系統數據',
  'RWD 響應式設計，手機預約流程一氣呵成',
];

const SuiSuiBookShowcase = () => {
  return (
    <motion.div
      variants={itemVariants}
      className="mb-16 rounded-2xl border border-secondary-800/30 bg-gradient-to-br from-slate-800/60 to-slate-900/60 overflow-hidden"
    >
      {/* 頂部標籤列 */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-b border-white/10">
        <div className="flex flex-wrap items-center gap-3">
          <span className="inline-block px-3 py-0.5 rounded-full bg-secondary-900/50 text-secondary-400 text-xs font-medium border border-secondary-800/40">
            精選展示
          </span>
          <h3 className="text-lg font-bold">SuiSui Book 美業預約系統</h3>
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-pink-900/30 text-pink-400 text-xs font-medium border border-pink-800/30">
            <FaStore className="text-[10px]" />
            多店家 SaaS
          </span>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://github.com/kaikaichumi/suisui-book"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-800/80 text-sm font-medium hover:bg-secondary-600 transition-colors"
          >
            <FaGithub />
            GitHub
          </a>
          <a
            href="https://suisui.kaienet.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-800/80 text-sm font-medium hover:bg-secondary-600 transition-colors"
          >
            <FaExternalLinkAlt />
            範例網站
          </a>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-0">
        {/* 左側：專案資訊 */}
        <div className="lg:col-span-2 p-6 lg:border-r border-white/10">
          <p className="text-gray-300 text leading-relaxed mb-5">
            為美髮、美甲等美業店家打造的多店家線上預約系統。顧客可依服務項目、指定設計師與可預約時段完成訂位，
            店家有專屬後台管理服務、人員與預約狀態，另有總管理端統一管理各店帳號與整體營運數據。
          </p>

          <ul className="space-y-2.5 mb-6">
            {features.map((f, i) => (
              <li key={i} className="flex items-start gap-2.5 text-gray-300 text">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-secondary-500 shrink-0"></span>
                {f}
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-2">
            {[
              { icon: <FaVuejs className="text-green-400" />, label: 'Vue 3 + Vite' },
              { icon: <FaNodeJs className="text-green-500" />, label: 'Node.js / Express' },
              { icon: <FaDatabase className="text-emerald-400" />, label: 'MongoDB' },
              { icon: <FaDocker className="text-blue-400" />, label: 'Docker' },
              { icon: <FaCalendarCheck className="text-pink-400" />, label: '預約系統' },
            ].map(({ icon, label }) => (
              <span key={label} className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-800/60 text-xs font-medium">
                {icon} {label}
              </span>
            ))}
          </div>
        </div>

        {/* 右側：手機介面展示 */}
        <div className="p-6 flex flex-col items-center justify-center bg-slate-900/30">
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="w-full max-w-[280px] rounded-xl overflow-hidden border border-white/10 shadow-2xl shadow-black/40"
          >
            <img
              src="/images/suisui_01.png"
              alt="SuiSui Book 預約服務流程介面"
              className="w-full h-auto"
            />
          </motion.div>
          <p className="mt-4 text-xs text-gray-400 text-center">顧客端預約流程 — 選擇日期與時段</p>
          <a
            href="https://suisui.kaienet.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center gap-1.5 text-xs text-secondary-400 hover:text-secondary-300 transition-colors"
          >
            <FaExternalLinkAlt className="text-[10px]" />
            前往範例網站體驗
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default SuiSuiBookShowcase;
